/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-undef */
/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable no-useless-escape */
/* eslint-disable unicorn/better-regex */
/* eslint-disable prettier/prettier */

class HeaderAndFooter {
	constructor() {
		window.addEventListener('resize', () => {
			this.toggleHeaderAndFooter();
		});
		window.dispatchEvent(new Event('resize'));
	}
	toggleHeaderAndFooter() {
		// this will activate only when the query parameter is passed from the mobile app.

		if (document.querySelector('body')) {
			let isLTAPLAYMOBILE = document.querySelector('body').getAttribute('data-is-LTAPLAYMOBILE');
			if(localStorage.getItem("isLTAPLAYMOBILE")=="true") {
					isLTAPLAYMOBILE = "True";
				}
			if (isLTAPLAYMOBILE !== null && isLTAPLAYMOBILE !== undefined && isLTAPLAYMOBILE == "True") {
				
				// header
				if (document.querySelector('nav').classList.contains('lta-mega-nav--is-visible')) {
                    document.querySelector('nav').classList.remove('lta-mega-nav--is-visible');
                    document.querySelector('nav').classList.add('lta-mega-nav--is-hidden');
                    document.querySelector('body').classList.add('no-nav');
                    document.querySelector('body').classList.remove('add-nav');
                    document.querySelector('body').classList.remove('with-nav');
                }
                //footer
                if (document.querySelector('.lta-footerv2-main')) {
					document.querySelector('.lta-footerv2-main').style.display = 'none';
                }	
								
				const elementsToHide = document.querySelectorAll('.mobile-play-tennis-modification');

				if (elementsToHide) {
					elementsToHide.forEach(element => {
						element.style.display = 'none';
					});
				}

				const mobilePlayElementsToHide = document.querySelectorAll('.mobile-play-tennis-visibility-hidden');

				if (mobilePlayElementsToHide) {
					mobilePlayElementsToHide.forEach(element => {
						element.style.visibility = 'hidden';
					});
				}

				localStorage.setItem("isLTAPLAYMOBILE", true);
				
			}
		}
	}
}
const pageManager = new HeaderAndFooter();
export default pageManager;